import React, { useEffect, useState } from 'react';
import { RuleElement } from '../../../../rule-element';
import { AltTextImageItemContent } from './alt-text-image-item-content';
import { AltTextImageItemHeader } from './alt-text-image-item-header';
export const AltTextImageItem = _ref => {
  let {
    id,
    imageUrl,
    altText,
    isDecorative,
    isLinked,
    status,
    isOpen,
    isLoading = false,
    isDisabled = false,
    showDecorativeOption = true,
    onClick,
    onValueChange,
    onDecorativeChange,
    onBlur,
    onStatusChange,
    onShowPrefixIconTooltip,
    translations,
    helperTip,
    inputSuffix,
    labelSize,
    topContent,
    formValidation,
    prefixStatusIconTooltip,
    width = 'normal',
    iconButtonPriority,
    iconButtonSkin,
    notHoveredBorderColor,
    hoveredBorderColor,
    showEnlargeButton = true,
    onEnlargeClick,
    isImageEnlarged = false
  } = _ref;
  const [localValue, setLocalValue] = useState(altText);
  useEffect(() => {
    setLocalValue(altText);
  }, [altText]);
  const handleValueChange = newValue => {
    setLocalValue(newValue);
    onValueChange(newValue);
  };
  return /*#__PURE__*/React.createElement(RuleElement, {
    contentComponent: /*#__PURE__*/React.createElement(AltTextImageItemContent, {
      decorativeDisabledTooltip: translations.decorativeDisabledTooltip,
      decorativeLabel: translations.decorativeLabel,
      formStatus: formValidation == null ? void 0 : formValidation.status,
      helperTip: helperTip,
      inputSuffix: inputSuffix,
      isDecorative: isDecorative,
      isDisabled: isDisabled || isLoading,
      isLinked: isLinked,
      label: translations.inputLabel,
      labelSize: labelSize,
      placeholder: translations.inputPlaceholder,
      showDecorativeOption: showDecorativeOption,
      status: status,
      statusMessage: formValidation == null ? void 0 : formValidation.message,
      topContent: topContent,
      value: localValue,
      onBlur: onBlur,
      onDecorativeChange: onDecorativeChange,
      onValueChange: handleValueChange
    }),
    disabled: isDisabled,
    headerComponent: /*#__PURE__*/React.createElement(AltTextImageItemHeader, {
      altText: altText,
      decorativeText: translations.decorativeText,
      imageUrl: imageUrl,
      isDecorative: isDecorative,
      isImageEnlarged: isImageEnlarged,
      isLinked: isLinked,
      isLoading: isLoading,
      isOpen: isOpen,
      placeholderText: translations.placeholderText,
      showEnlargeButton: showEnlargeButton,
      onEnlargeClick: onEnlargeClick
    }),
    hoveredBorderColor: hoveredBorderColor,
    iconButtonAriaLabel: translations.editAriaLabel,
    iconButtonPriority: iconButtonPriority,
    iconButtonSkin: iconButtonSkin,
    iconButtonToolTip: translations.editTooltip,
    id: id,
    isLoading: isLoading,
    isOpen: isOpen,
    notHoveredBorderColor: notHoveredBorderColor,
    prefixStatusIconTooltip: prefixStatusIconTooltip,
    status: status,
    width: width,
    onClick: onClick,
    onShowPrefixIconTooltip: onShowPrefixIconTooltip,
    onStatusChange: onStatusChange
  });
};
//# sourceMappingURL=alt-text-image-item.js.map